import React from "react";
import { useEffect, useRef, useState } from "react";
import { Paint, PaintFile } from "../types/Paint";
import PaintServiceClient from "../services/paint-service.client";
import ViewPaint from "./view";


const RecentPaintsList = () => {
  const paintService = useRef(new PaintServiceClient());
  const [paints, setPaints] = useState<Paint[]>([]);
  const [selectedPaint, setSelectedPaint] = useState<Paint | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);

  const fetch = () => {
    paintService.current.recent(page, 25)
      .then((paints) => setPaints(paints))
      .catch((e) => setError(e.Message));
  }

  useEffect(() => {
    fetch();
  }, []);


  useEffect(() => {
    paintService.current.recent(page, 25)
      .then((paints) => setPaints(paints))
      .catch((e) => setError(e.Message)); 
  }, [page]);

  const getFrontAngle = (paint: Paint): PaintFile | undefined =>{
    return paint.files.find(file => file.type === "image-front-angle");
  };

  const modalClosed = () => {
    setSelectedPaint(null);
    setError(null);
    fetch();
  };

  

  return (
    <>
    {error && <div>{error}</div>}

    <h1>Recently Uploaded Paints</h1>
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      {paints.map((paint) => (
        <div key={paint.id} style={{ margin: "10px", cursor: "pointer" }}>
          <img height="175px" src={getFrontAngle(paint)?.uri} alt="" onClick={() => setSelectedPaint(paint)} />
        </div>
      ))}
    </div>

    <div>
      <button onClick={() => setPage(page - 1)} disabled={page <= 1} className="btn btn-primary" style={{ marginRight: "10px" }}>
        Previous
      </button>
      <button onClick={() => setPage(page + 1)} disabled={paints.length < 25} className="btn btn-primary">
        Next
      </button>
    </div>

    {selectedPaint && (
      <ViewPaint 
        selectedPaint={selectedPaint}
        handleClose={() => modalClosed()}
        onError={(message) => setError(message)}    
      />
    )}
    </>
  )
}

export default RecentPaintsList;
